import React from 'react';

export type StatusIconType = 'success' | 'warning' | 'error';

export default function StatusIcon({
	type,
	...props
}: {
	type: StatusIconType;
}) {
	return (
		<div className={`common-ui-status-icon`} aria-hidden="true" {...props}>
			<div className={`inner-icon ${type}`} />
		</div>
	);
}
